import React, { createContext, useMemo } from "react";
import { EMPTY_OBJ } from "../../../helpers/logic/empties";
import SidebarBar from "../../components/SidebarBar";
import { SIDEBAR_TOTAL_WIDTH } from "../../components/SidebarBar/constants";
import SidebarWrapper from "../../components/SidebarWrapper";
import { TRANSITION_DURATION } from "./constants";
import useSidebar from "./hooks/useSidebar";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SidebarContext = /*#__PURE__*/createContext({
  isSidebarOpen: false,
  openSidebar: function openSidebar(_content) {
    // comment allows empty default
  },
  closeSidebar: function closeSidebar() {
    // comment allows empty default
  },
  sidebarContent: null,
  TRANSITION_DURATION: TRANSITION_DURATION,
  SIDEBAR_WIDTH: SIDEBAR_TOTAL_WIDTH
});
function SidebarProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  var _ref2 = config || EMPTY_OBJ,
    topOffset = _ref2.topOffset;
  var sidebarValue = useSidebar();
  var value = useMemo(function () {
    return sidebarValue;
  }, [sidebarValue]);
  var isSidebarOpen = value.isSidebarOpen,
    sidebarContent = value.sidebarContent,
    closeSidebar = value.closeSidebar,
    openSidebar = value.openSidebar;
  return /*#__PURE__*/_jsx(SidebarContext.Provider, {
    value: value,
    children: /*#__PURE__*/_jsxs(SidebarWrapper, {
      isOpen: isSidebarOpen,
      children: [children, /*#__PURE__*/_jsx(SidebarBar, {
        topOffset: topOffset,
        isOpen: isSidebarOpen,
        closeSidebar: closeSidebar,
        openSidebar: openSidebar,
        children: sidebarContent
      })]
    })
  });
}
export { SidebarProvider, SidebarContext };